import React, { useEffect, useState, useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import api, { API_URL, APPNAME, AuthContext } from "./util/api";

export default function Navbar() {
  const { token, User, logout, Doctor } = useContext(AuthContext);
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [dashboardLink, setDashboardLink] = useState("/dashboard");
  const [profileLink, setProfileLink] = useState("");
  const [messageLink, setMessageLink] = useState("");
  const [noticount, setNotification] = useState(0);
  const [messageCount, setMessageCount] = useState(0);

  const isAuthenticated = Boolean(token && User);

  const fetchNotificationCount = async () => {
    const res = await api.get(`${API_URL}/notification_count`);
    if (res.status === 200 && res.data.status === "successful") {
      setNotification(res.data.notification_count);
      setMessageCount(res.data.chat_count);
    }
  };

  useEffect(() => {
    if (!User) return;
    fetchNotificationCount();
    const t = setInterval(fetchNotificationCount, 600000);
    return () => clearInterval(t);
  }, [User]);

  useEffect(() => {
    if (!User) return;

    if (User.role === "doctor") {
      setDashboardLink("/doctor-dashboard");
      setProfileLink("/doctor-profile-reg");
      setMessageLink("/doctor-ongoing-appointments");
    }

    if (User.role === "patient") {
      setDashboardLink("/patient-dashboard");
      setProfileLink("/patient-reg");
      setMessageLink("/patient-ongoing-appointments");
    }

    if (User.role === "none") {
      setDashboardLink("/select-role");
      setProfileLink("/select-role");
    }
  }, [User]);

  const logoutf = () => {
    logout();
    navigate("/login");
  };

  return (
    <>
      <header className="clean-header">
        <div className="clean-inner">

          {/* LOGO */}
          {isAuthenticated && (
            <Link to="/" className="clean-logo">
              {APPNAME}
            </Link>
          )}

          {/* DESKTOP MENU */}
          <nav className="clean-nav">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/doctors">Doctors</NavLink>
            <NavLink to="/about-us">About</NavLink>

            {isAuthenticated ? (
              <NavLink to={dashboardLink}>Dashboard</NavLink>
            ) : null}


            {isAuthenticated ? (
              <NavLink to="/payment_details">Payment Info</NavLink>
            ) : null}


          </nav>

          {/* RIGHT ICONS (ALWAYS VISIBLE) */}
          <div className="clean-right">

            {isAuthenticated && (
              <>
                <NavLink to={messageLink} className="icon-btn">
                  ✉️
                  {messageCount > 0 && <span>{messageCount}</span>}
                </NavLink>

                <NavLink to="/notifications" className="icon-btn">
                  🔔
                  {noticount > 0 && <span>{noticount}</span>}
                </NavLink>
              </>
            )}

            {/* ACCOUNT */}

            <div className="account-menu">
              <button style={{ color: 'black' }} onClick={() => setMenuOpen(!menuOpen)}>Menu☰</button>
              {(menuOpen && isAuthenticated) && (
                <div className="account-dropdown">
                  {User?.role === "doctor" && (
                    <Link to={`/doctor-profile/${Doctor?.id}`}>
                      View Profile
                    </Link>
                  )}
                  <Link to={profileLink}>Edit Profile</Link>
                  <button onClick={logoutf} className="danger">
                    Logout
                  </button>
                </div>
              )}
            </div>
            {!isAuthenticated && (
              <div className="auth-links">
                <NavLink to="/login">Login</NavLink>
                <NavLink to="/register" className="primary">
                  Register
                </NavLink>
              </div>
            )}

          </div>
        </div>

        {/* MOBILE MENU */}
        {menuOpen && (
          <div className="mobile-menu">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/doctors">Doctors</NavLink>
            <NavLink to="/about-us">About</NavLink>
            {isAuthenticated && <NavLink to={dashboardLink}>Dashboard</NavLink>}

            {isAuthenticated && <NavLink to="/payment_details">Payment Info</NavLink>}

          </div>
        )}
      </header>

      <style>{`
        .clean-header {
          background: #ffffff;
          border-bottom: 1px solid #e5e7eb;
          position: sticky;
          top: 0;
          z-index: 1000;
        }

        .clean-inner {
          max-width: 1200px;
          margin: auto;
          padding: 14px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .clean-logo {
          font-size: 20px;
          font-weight: 700;
          color: #111827;
          text-decoration: none;
        }

        .clean-nav {
          display: flex;
          gap: 24px;
        }

        .clean-nav a {
          text-decoration: none;
          color: #374151;
          font-weight: 500;
        }

        .clean-nav a.active {
          border-bottom: 2px solid #2563eb;
        }

        .clean-right {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .icon-btn {
          position: relative;
          font-size: 18px;
          text-decoration: none;
          color: #111;
        }

        .icon-btn span {
          position: absolute;
          top: -6px;
          right: -10px;
          background: crimson;
          color: white;
          font-size: 11px;
          padding: 2px 6px;
          border-radius: 999px;
        }

        .account-menu button {
          background: none;
          border: none;
          font-size: 20px;
        }

        .account-dropdown {
          position: absolute;
          right: 5cm;
          top: 60px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 10px 30px rgba(0,0,0,.1);
          overflow: hidden;
        }

        .account-dropdown a,
        .account-dropdown button {
          display: block;
          padding: 12px 16px;
          width: 100%;
          text-align: left;
          border: none;
          background: none;
          text-decoration: none;
          color: #111;
        }

        .account-dropdown .danger {
          color: crimson;
        }

        .auth-links a {
          margin-left: 12px;
          text-decoration: none;
        }

        .auth-links .primary {
          background: #2563eb;
          color: white;
          padding: 6px 12px;
          border-radius: 6px;
        }

        .mobile-menu {
          display: none;
          flex-direction: column;
          background: #f9fafb;
          padding: 14px 20px;
        }

        @media (max-width: 768px) {
          .clean-nav {
            display: none;
          }
          .account-dropdown {
            right: 1cm;
          }

          .mobile-menu {
            display: flex;
            gap: 14px;
          }
        }
      `}</style>
    </>
  );
}
